import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="section-pad min-h-[60vh] grid place-items-center text-center">
      <div>
        <p className="text-sm tracking-[0.2em] uppercase text-brand-leaf mb-6">404</p>
        <h1 className="font-heading font-light text-4xl md:text-5xl">
          We couldn't find that page.
        </h1>
        <p className="mt-5 text-brand-muted">Let's get you back home.</p>
        <Link
          data-testid="notfound-home-btn"
          to="/"
          className="mt-8 inline-flex rounded-full bg-brand-ink text-brand-cream px-7 py-3.5 text-sm hover:bg-brand-leaf transition-colors"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
